module.exports = __webpack_public_path__ + "built-card-top-right.1YLgLiyW.png";